<template>
  <div v-if="plan.is_trial">
    <div class="d-flex justify-content-between">
      <h6 class="plan-item__trial-title">
        {{ plan.name }}
      </h6>
      <div class="d-flex">
        <CIcon name="cipCircleCheckFill" size="custom-size" width="24" class="ml-2 text-primary"
               v-if="selectedPlan === plan.id"/>
        <CIcon name="cipCircle" size="custom-size" width="24" class="ml-2" v-else/>
      </div>
    </div>
    <div class="plan-item__trial-descr">
      <div>
        <translate translate-context="public_plan.trial" :translate-params="{num: plan.media_included}">
          Max %{num} photo uploads
        </translate>
      </div>
      <div v-translate translate-context="public_plan.trial">no credit card required</div>
    </div>
  </div>
  <div v-else>
    <div class="d-flex justify-content-between plan-switcher__head">
      <h6 class="plan-item__title">
        <CIcon name="cipCube01" size="custom" :height="20" class="mr-1" style="vertical-align: sub"/>
        {{ plan.name }}
      </h6>
      <div class="d-flex">
        <CBadge class="badge-outline" shape="pill" color="success">
          <template v-if="plan.recommended_participants">
            <translate translate-context="public_plan.base">Ideal for</translate>
            ~{{ plan.recommended_participants }}
            <translate translate-context="public_plan.base">guests</translate>
          </template>
          <template v-else>
            <translate translate-context="public_plan.base">No extra costs</translate>
          </template>
        </CBadge>
        <CIcon name="cipCircleCheckFill" size="custom-size" width="24" class="ml-2 text-primary"
               v-if="selectedPlan === plan.id"/>
        <CIcon name="cipCircle" size="custom-size" width="24" style="color: #CECCE8" class="ml-2" v-else/>
      </div>
    </div>
    <h4 class="plan-item__price">
      <template v-if="isEcommerce">
        <span class="value">{{ parseInt(plan.pica_fee_perc) }}%</span>
        <span class="value-text"> / <translate translate-context="public_plan.base">on transactions</translate></span>
        <span class="vat" v-translate translate-context="public_plan.base">Vat incl.</span>
      </template>
      <template v-else-if="plan.is_subscription">
        <template v-if="priceType === 'yearly'">
          <span class="value">{{ plan.yearly_price|currency(currency) }}</span> /
          <translate translate-context="public_plan.base">year</translate>
        </template>
        <template v-else>
          <span class="value">{{ plan.monthly_price|currency(currency) }}</span> /
          <translate translate-context="public_plan.base">month</translate>
        </template>
      </template>
      <template v-else>
        <span class="value">{{ plan.price|currency(currency) }}</span>
        <span class="value-text"> / <translate translate-context="public_plan.base">event</translate></span>
        <span class="vat" v-translate translate-context="public_plan.base">Vat incl.</span>
      </template>
    </h4>
    <div class="d-flex align-items-end justify-content-between">
      <div class="text-primary">
        <span class="font-weight-bold mr-1">{{ plan.media_included|number(0) }}</span>
        <span class="" v-translate translate-context="public_plan.base">photos upload included</span>
      </div>
    </div>
    <div class="mt-1 " v-if="plan.max_collaborators && plan.max_collaborators > 0">
        <div class="d-flex align-items-center text-primary">
          <CIcon name="cipUser" size="custom-size" :height="14" class="mr-1"/>
          <span class="font-weight-bold mr-1">
            <translate translate-context="public_plan.base"
                           :translate-params="{count: plan.max_collaborators}"
                           :translate-n="plan.max_collaborators"
                           translate-plural="%{count} collaborators">
              %{count} collaborator
            </translate>
          </span>
          <translate translate-context="public_plan.base"
                         :translate-n="plan.max_collaborators"
                         translate-plural="included">
            included
          </translate>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PlanItem",
  props: {
    plan: {
      type: Object,
      required: true
    },
    currency: {
      type: String,
      required: true
    },
    selectedPlan: {
      type: Number,
      default: null
    },
    priceType: {
      type: String,
      default: 'monthly'
    },
    isEcommerce: {
      type: Boolean,
      default: false
    }
  },
}
</script>


<style scoped>

</style>